module.exports = __webpack_public_path__ + "img/libao.d35b9b35.png";